import actions from './usersActions'
import mutations from './usersMutations'

export default {
  namespaced: true,
  actions,
  mutations
}